"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRouterContext = exports.getRouterContext = exports.router = void 0;

var kea_1 = require("kea");

var utils_1 = require("./utils");

function preventUnload() {
  var _a;

  var beforeUnloadInterceptors = getRouterContext().beforeUnloadInterceptors;

  if (!beforeUnloadInterceptors) {
    return;
  }

  for (var _i = 0, _b = Array.from(beforeUnloadInterceptors); _i < _b.length; _i++) {
    var beforeUnload = _b[_i];

    if (!beforeUnload.enabled()) {
      continue;
    }

    if (confirm(beforeUnload.message)) {
      (_a = beforeUnload.onConfirm) === null || _a === void 0 ? void 0 : _a.call(beforeUnload);
      return false;
    }

    return true;
  }

  return false;
}

exports.router = (0, kea_1.kea)([(0, kea_1.path)(['kea', 'router']), (0, kea_1.actions)({
  push: function push(url, searchInput, hashInput) {
    return {
      url: url,
      searchInput: searchInput,
      hashInput: hashInput
    };
  },
  replace: function replace(url, searchInput, hashInput) {
    return {
      url: url,
      searchInput: searchInput,
      hashInput: hashInput
    };
  },
  locationChanged: function locationChanged(_a) {
    var method = _a.method,
        pathname = _a.pathname,
        search = _a.search,
        searchParams = _a.searchParams,
        hash = _a.hash,
        hashParams = _a.hashParams,
        initial = _a.initial;
    return {
      method: method,
      pathname: pathname,
      search: search,
      searchParams: searchParams,
      hash: hash,
      hashParams: hashParams,
      initial: initial || false
    };
  }
}), (0, kea_1.reducers)(function () {
  return {
    location: [getLocationFromContext(), {
      locationChanged: function locationChanged(_, _a) {
        var pathname = _a.pathname,
            search = _a.search,
            hash = _a.hash;
        return {
          pathname: pathname,
          search: search,
          hash: hash
        };
      }
    }],
    searchParams: [getRouterContext().decodeParams(getLocationFromContext().search, '?'), {
      locationChanged: function locationChanged(_, _a) {
        var searchParams = _a.searchParams;
        return searchParams;
      }
    }],
    hashParams: [getRouterContext().decodeParams(getLocationFromContext().hash, '#'), {
      locationChanged: function locationChanged(_, _a) {
        var hashParams = _a.hashParams;
        return hashParams;
      }
    }],
    lastMethod: [null, {
      locationChanged: function locationChanged(_, _a) {
        var method = _a.method;
        return method;
      }
    }]
  };
}), (0, kea_1.selectors)({
  currentLocation: [function (s) {
    return [s.location, s.searchParams, s.hashParams, s.lastMethod];
  }, function (location, searchParams, hashParams, method) {
    return __assign(__assign({}, location), {
      searchParams: searchParams,
      hashParams: hashParams,
      method: method
    });
  }]
}), (0, kea_1.sharedListeners)(function (_a) {
  var actions = _a.actions;
  return {
    updateLocation: function updateLocation(_a, breakpoint, action) {
      var _b;

      var url = _a.url,
          searchInput = _a.searchInput,
          hashInput = _a.hashInput;
      var method = action.type === actions.push.toString() ? 'push' : 'replace';
      var routerContext = getRouterContext();
      var history = routerContext.history;
      var response = (0, utils_1.combineUrl)(url, searchInput, hashInput);

      if (preventUnload()) {
        return;
      }

      routerContext.historyStateCount = ((_b = routerContext.historyStateCount) !== null && _b !== void 0 ? _b : 0) + 1;
      history["".concat(method, "State")]({
        count: routerContext.historyStateCount
      }, '', response.url);
      actions.locationChanged(__assign({
        method: method.toUpperCase()
      }, response));
    }
  };
}), (0, kea_1.listeners)(function (_a) {
  var sharedListeners = _a.sharedListeners;
  return {
    push: sharedListeners.updateLocation,
    replace: sharedListeners.updateLocation
  };
}), (0, kea_1.afterMount)(function (_a) {
  var actions = _a.actions,
      cache = _a.cache;

  if (typeof window === 'undefined') {
    return;
  }

  cache.popListener = function (event) {
    var _a;

    var routerContext = getRouterContext();
    var location = routerContext.location,
        decodeParams = routerContext.decodeParams;
    var eventStateCount = (_a = event.state) === null || _a === void 0 ? void 0 : _a.count;

    if (eventStateCount !== routerContext.historyStateCount && preventUnload()) {
      if (typeof eventStateCount !== 'number' || routerContext.historyStateCount === null) {
        return;
      }

      if (eventStateCount < routerContext.historyStateCount) {
        routerContext.historyStateCount = eventStateCount + 1;
        history.forward();
      } else {
        routerContext.historyStateCount = eventStateCount - 1;
        history.back();
      }

      return;
    }

    routerContext.historyStateCount = typeof eventStateCount === 'number' ? eventStateCount : routerContext.historyStateCount;

    if (location) {
      actions.locationChanged({
        method: 'POP',
        pathname: location.pathname,
        search: location.search,
        searchParams: decodeParams(location.search, '?'),
        hash: location.hash,
        hashParams: decodeParams(location.hash, '#'),
        url: "".concat(location.pathname).concat(location.search).concat(location.hash)
      });
    }
  };

  window.addEventListener('popstate', cache.popListener);
}), (0, kea_1.beforeUnmount)(function (_a) {
  var cache = _a.cache;

  if (typeof window === 'undefined') {
    return;
  }

  window.removeEventListener('popstate', cache.popListener);
})]);

function getRouterContext() {
  return (0, kea_1.getPluginContext)('router');
}

exports.getRouterContext = getRouterContext;

function setRouterContext(context) {
  (0, kea_1.setPluginContext)('router', context);
}

exports.setRouterContext = setRouterContext;

function getLocationFromContext() {
  var _a = getRouterContext().location,
      pathname = _a.pathname,
      search = _a.search,
      hash = _a.hash;
  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}